"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _transition = _interopRequireDefault(require("../helpers/transition"));

var _withCustomPaletteColor = _interopRequireDefault(require("../withCustomPaletteColor"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: 2px;\n  position: relative;\n  padding: ", ";\n\n  &:focus,\n  &:active {\n    box-shadow: unset;\n  }\n\n  &.selected {\n    background-color: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n\n  &.selected:hover {\n    background-color: ", ";\n    color: ", ";\n    border-color: ", ";\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var getColorPalette = function getColorPalette(props) {
  if (props.color === 'default') {
    var main = props.theme.palette.grey[300];
    return {
      main: main,
      light: props.theme.palette.grey[200],
      dark: props.theme.palette.grey[600],
      contrastText: props.theme.palette.getContrastText(main)
    };
  }

  return props.theme.palette[props.color] || props.theme.palette.primary;
};

var afterBtn = function afterBtn(props) {
  return "\n  opacity: 0;\n  display: block;\n  content: '';\n  box-sizing: content-box;\n  position: absolute;\n  height: calc(100% - 2px);\n  width: calc(100% - 2px);\n  top: -1px;\n  left: -1px;\n  border: 2px solid ".concat(getColorPalette(props).main, ";\n  transition: ").concat((0, _transition.default)(props.theme.transitions).join(','), ";\n");
};

var outlinedStyle = function outlinedStyle(props) {
  return "\n  color: ".concat(props.theme.palette.common.black, "\n  border: 1px solid ").concat(props.theme.palette.grey[400], ";\n  transition: ").concat((0, _transition.default)(props.theme.transitions).join(','), ";\n\n  &::after {\n    ").concat(afterBtn(props), "\n    border-radius: 2px;\n  }\n  &:hover::after {\n    opacity: 1;\n  }\n\n  &:hover {\n    background-color: ").concat(props.theme.palette.getLighterColor(getColorPalette(props).main), ";\n    color: ").concat(props.theme.palette.getContrastText(props.theme.palette.getLighterColor(getColorPalette(props).main)), ";\n    border: 1px solid transparent;\n  }\n\n  & + & {\n    border-left-color: transparent;\n    margin-left: -1px;\n  }\n\n  &.selected {\n    border-color: ").concat(getColorPalette(props).main, ";\n  }\n  &.selected::after {\n    opacity: 0;\n  }\n");
};

var containedStyle = function containedStyle(props) {
  return "\n  &:hover, &.selected {\n    background: ".concat(getColorPalette(props).dark, ";\n    color: ").concat(props.theme.palette.getContrastText(getColorPalette(props).dark), ";\n  }\n  &.selected:hover {\n    background: ").concat(props.theme.palette.getDarkerColor(getColorPalette(props).main), ";\n    color: ").concat(props.theme.palette.getContrastText(props.theme.palette.getDarkerColor(getColorPalette(props).main)), ";\n  }\n");
};

var fabStyle = function fabStyle(props) {
  return "\n  box-shadow: unset;\n  border-radius: 50%;\n\n  ".concat(props.color === 'default' && "\n    color: ".concat(props.theme.palette.grey[800], ";\n    background-color: white;\n    border: 1px solid ").concat(props.theme.palette.grey[400], ";\n    transition: ").concat((0, _transition.default)(props.theme.transitions).join(','), ";;\n\n    &::after{\n      ").concat(afterBtn(props), "\n      border-radius: 50%;\n    }\n    &:hover::after {\n      opacity: 1;\n    }\n\n    &:hover {\n      background-color: ").concat(props.theme.palette.getLighterColor(getColorPalette(props).main), ";\n      color: ").concat(props.theme.palette.getContrastText(props.theme.palette.getLighterColor(getColorPalette(props).main)), ";\n      border: 1px solid transparent;\n    }\n  "), "\n");
};

var StyledButton = (0, _styledComponents.default)(_core.Button)(_templateObject(), function (props) {
  return props.size === 'large' && '14px 32px';
}, function (props) {
  return getColorPalette(props).main;
}, function (props) {
  return getColorPalette(props).contrastText;
}, function (props) {
  return getColorPalette(props).main;
}, function (props) {
  return getColorPalette(props).dark;
}, function (props) {
  return props.theme.palette.getContrastText(getColorPalette(props).dark);
}, function (props) {
  return getColorPalette(props).dark;
}, function (props) {
  switch (props.variant) {
    case 'outlined':
      return outlinedStyle(props);

    case 'contained':
      return containedStyle(props);

    case 'fab':
      return fabStyle(props);

    default:
      return '';
  }
});

var Button = function Button(props) {
  return props.selected ? _react.default.createElement(StyledButton, Object.assign({}, props, {
    className: [props.className, 'selected'].join(' ')
  })) : _react.default.createElement(StyledButton, props);
};

Button.defaultProps = {
  color: 'default',
  disableRipple: false,
  disabled: false,
  selected: false,
  fullWidth: false,
  mini: false,
  size: 'medium',
  variant: 'text'
};

var _default = (0, _withCustomPaletteColor.default)(Button);

exports.default = _default;